module.exports = __webpack_public_path__ + "static/media/video.c9aee28d.svg";